import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineChevronLeft } from 'react-icons/hi';
import { useAuth } from '../../context/AuthContext';
import { hasCardAction } from '../../utils/permissionHelper';
import UploadTab from './components/UploadTab';
import AnalyticsTab from './components/AnalyticsTab';
import './FinancialReports.css';

const CARD = 'financial-performance';

const FinancialReports = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    const isAdmin = user?.role === 'system_admin';
    const perms = user?.permissions || { cards: [], actions: [] };

    // Per user's spec: Upload tab is only for admin OR users with both create + approve
    const canCreate  = isAdmin || hasCardAction(perms, CARD, 'create');
    const canApprove = isAdmin || hasCardAction(perms, CARD, 'approve');
    const canEdit    = isAdmin || hasCardAction(perms, CARD, 'edit');
    const canDelete  = isAdmin || hasCardAction(perms, CARD, 'delete');
    const canSeeUpload = isAdmin || (canCreate && canApprove);

    const tabs = useMemo(() => {
        const base = [
            { id: 'analytics', label: 'Analytics & Comparison', icon: '📊' }
        ];
        if (canSeeUpload) {
            base.push({ id: 'upload', label: 'Upload & Manage', icon: '📤' });
        }
        return base;
    }, [canSeeUpload]);

    const [activeTab, setActiveTab] = useState(tabs[0].id);

    return (
        <div className="fr-shell">
            <header className="fr-header">
                <div className="fr-header-left">
                    <button className="fr-back-btn" onClick={() => navigate('/purpose-selection')}>
                        <HiOutlineChevronLeft size={20} />
                    </button>
                    <div className="fr-header-title">
                        <h1>Financial Performance</h1>
                        <span>P&L Analytics — month, year and trend comparison</span>
                    </div>
                </div>
            </header>

            <nav className="fr-nav">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`fr-nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <span className="fr-nav-tab-icon">{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}
            </nav>

            <main className="fr-body">
                {activeTab === 'analytics' && <AnalyticsTab />}
                {activeTab === 'upload' && canSeeUpload && (
                    <UploadTab
                        canCreate={canCreate}
                        canApprove={canApprove}
                        canEdit={canEdit}
                        canDelete={canDelete}
                    />
                )}
            </main>
        </div>
    );
};

export default FinancialReports;
